<template>
  <section class="aboutus-info">
    <div class="container">
      <!-- Banners -->
      <div class="row d-flex align-items-center">
        <div class="col-12 col-sm-3 col-md-3 col-lg-3">
          <div class="banner text-center">
            <img
              src="@/assets/img/aboutus/about-us-1.jpg"
              class="img-fluid corner-radius-10"
              alt="Banner-01"
            />
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
          <div class="banner text-center">
            <img
              src="@/assets/img/aboutus/ubout-us-3.jpg"
              class="img-fluid corner-radius-10"
              alt="Banner-02"
            />
          </div>
        </div>
        <div class="col-12 col-sm-3 col-md-3 col-lg-3">
          <div class="banner text-center">
            <img
              src="@/assets/img/aboutus/about-us-2.jpg"
              class="img-fluid corner-radius-10"
              alt="Banner-03"
            />
          </div>
        </div>
      </div>
      <!-- /Banners -->

      <!-- Vision-Mission -->
      <div class="vision-mission">
        <div class="row">
          <div  >
            <div v-for="item in about" :key="item.id"> 
              <div v-if="item.type == 'about'">
                <h2>{{ item.title }}</h2>
                <div style="color: black;" v-html="item.description"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Vision-Mission -->
    </div>
  </section>
</template>
<script>
import { getPolicy } from '@/api/strapi/policy';

export default {
  data() {
    return {
      about:[],
    };
  },
  methods:{
    async fetchAbout(){
      try{
        const response = await getPolicy();
        this.about = response.data;
      }catch(error){
        console.log('Lỗi lấy dữ liệu: ',error);
      }
    }
  },
  async created(){
    await this.fetchAbout();
  }
}
</script>